import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles(theme => ({
  container: {
    background: '#1F1F1F',
    width: 'calc(20% - 20px)',
    boxSizing: 'border-box',
    marginTop: 6,
    position: 'relative',
    cursor: 'pointer',
    [theme.media.tablet]: {
      width: 'calc(25% - 20px)'
    },
    [theme.media.mobile]: {
      width: 'calc(33% - 20px)'
    },
    [theme.media.smallMobile]: {
      width: 'calc(50% - 20px)'
    }
  },

  imgix: {
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundPosition: 'top',
    objectFit: 'cover',
    objectPosition: 'top',
    border: '1px solid transparent',
    borderRadius: theme.cardBorderRadius,
    background: 'linear-gradient(transparent, transparent) padding-box, linear-gradient(135deg, rgba(255,255,255,0.4), transparent 20%, rgba(255,255,255,0.2)) border-box'
  },

  hoverOverlay: {
    width: '100%',
    height: '100%',
    border: `${theme.neonPrimary} 4px solid`,
    position: 'absolute',
    borderRadius: theme.cardBorderRadius,
    opacity: 0,
    inset: 0,
    boxSizing: 'border-box',
    transition: 'opacity 300ms ease-in'
  },

  hoverOverlayVisible: {
    [theme.media.desktop]: {
      opacity: 1
    }
  },

  selectedOverlay: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(16, 16, 16, 0.3)',
    border: `${theme.neonPrimary} 4px solid`,
    borderRadius: theme.cardBorderRadius
  },

  selectedButton: {
    position: 'absolute',
    bottom: 16,
    left: 16
  },

  fadeOut: {
    animation: '$fadeOutOpacity 1s forwards'
  },

  '@keyframes fadeOutOpacity': {
    '0%': {
      opacity: 1
    },

    '100%': {
      opacity: 0
    }
  }
}))
